import * as overviewTypes from './overviewTypes';

const initialState = {
  filter: undefined,
  flagsId: undefined,
  flagsIndex: undefined,
  primaryServiceRepresentative:''
};

const overviewFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case overviewTypes.CLEAR_FILTER:
      return { ...state, ...initialState, primaryServiceRepresentative: '' };

    case overviewTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export { initialState };
export default overviewFilterReducer;
